import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, loading, titleControls, job, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading} controls={titleControls}/>
      <Notice
        display={job && job.archived}
        message={[
          'This subscription has been archived and is therefore no longer available.',
          'You won\'t be able to modify it unless it is restored.'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['subscription']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Subscriptions', link: routes.subscriptions.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: reverse(routes.archive.index)},
  {title: 'Subscriptions', link: reverse(routes.archive.index, {tab: 'subscriptions'})}
];

export default Wrapper;
